/* sb-flyout-aim.js: hover intent ("safe triangle") for the desktop header's
   nested flyouts (Shoes > Women's / Men's / Kid's Shoes). Oct 2026.

   The theme opens these boxes with CSS :hover, so moving the mouse diagonally from
   "Women's Shoes" toward its box swaps to "Men's Shoes" as soon as the pointer
   crosses that row. This script decides which row is "really" open and marks it
   with .sb-aim-open. sb-flyout-fix.css shows boxes by that class while
   <html> has .sb-aim-ready.
     - Pointer heading toward the open box  -> wait 250ms before switching rows.
     - Any other movement / pause           -> switch immediately.
   Desktop + mouse only (min-width 981px). Without this script (or if it fails)
   <html> never gets .sb-aim-ready and the menu falls back to pure CSS hover.
   No links/hrefs are touched. Undo: remove the <script> line for this file. */
(function () {
  'use strict';
  if (window.__sbFlyoutAim) return;            // idempotent
  window.__sbFlyoutAim = true;

  var DELAY = 250;          // ms to wait while the pointer is aiming at the open box
  var TOL = 25;             // px of slack above/below the box for the triangle
  var READY = 'sb-aim-ready', OPEN = 'sb-aim-open';
  var root = document.documentElement;
  var mq = window.matchMedia ? window.matchMedia('(min-width: 981px) and (hover: hover) and (pointer: fine)') : null;

  var openRow = null, lastRow = null, pendingTimer = null, closeTimer = null, pts = [], posAtTimer = null;

  function nestedBox(row) {
    if (!row) return null;
    for (var c = row.firstElementChild; c; c = c.nextElementSibling)
      if (c.classList && c.classList.contains('dropdown--nested')) return c;
    return null;
  }

  // The first-level row (li directly inside the Shoes dropdown) that contains el.
  function levelRow(el) {
    for (var n = el && el.nodeType === 1 ? el : el && el.parentElement; n && n !== document.body; n = n.parentElement) {
      if (n.classList && n.classList.contains('dropdown__menuitem') && n.parentElement &&
          n.parentElement.classList.contains('dropdown') &&
          !n.parentElement.classList.contains('dropdown--nested') &&
          n.closest('.navigation')) return n;
    }
    return null;
  }

  function clearPending() { if (pendingTimer) { clearTimeout(pendingTimer); pendingTimer = null; } }

  function ensureEdge(box) {             // same test theme.js uses, for boxes opened late
    if (!box || box.classList.contains('dropdown--edge')) return;
    var r = box.getBoundingClientRect();
    if (r.width && r.left + r.width >= root.clientWidth) box.classList.add('dropdown--edge');
  }

  function activate(row) {
    clearPending();
    if (openRow === row) return;
    if (openRow) openRow.classList.remove(OPEN);
    openRow = row;
    if (row && nestedBox(row)) { row.classList.add(OPEN); ensureEdge(nestedBox(row)); }
  }

  function closeAll() { clearPending(); if (openRow) openRow.classList.remove(OPEN); openRow = null; lastRow = null; pts = []; }

  function sign(p, a, b) { return (p.x - b.x) * (a.y - b.y) - (a.x - b.x) * (p.y - b.y); }
  function inTriangle(p, a, b, c) {
    var d1 = sign(p, a, b), d2 = sign(p, b, c), d3 = sign(p, c, a);
    var neg = d1 < 0 || d2 < 0 || d3 < 0, pos = d1 > 0 || d2 > 0 || d3 > 0;
    return !(neg && pos);
  }

  // Is the pointer travelling toward the open row's box?
  function aiming() {
    var box = nestedBox(openRow);
    if (!box || pts.length < 2) return false;
    var r = box.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var rr = openRow.getBoundingClientRect();
    var opensLeft = (r.left + r.right) / 2 < (rr.left + rr.right) / 2;
    var edgeX = opensLeft ? Math.max(r.right, rr.left) : Math.min(r.left, rr.right);  // where the hover area starts
    var prev = pts[0], cur = pts[pts.length - 1];
    if (prev.x === cur.x && prev.y === cur.y) return false;
    if (opensLeft ? cur.x >= prev.x : cur.x <= prev.x) return false;   // must move horizontally toward it
    return inTriangle(cur, prev, { x: edgeX, y: r.top - TOL }, { x: edgeX, y: r.bottom + TOL });
  }

  function recheck() {
    pendingTimer = null;
    var cur = pts[pts.length - 1];
    var row = lastRow;                                        // row under the pointer at the last move
    if (!row || row === openRow) return;                      // reached the box / back on row
    var moved = posAtTimer && cur && (cur.x !== posAtTimer.x || cur.y !== posAtTimer.y);
    if (moved && aiming()) { posAtTimer = cur; pendingTimer = setTimeout(safe(recheck), DELAY); return; }
    activate(row);                                            // paused or changed course
  }

  function onMove(e) {
    if (!root.classList.contains(READY)) return;
    var top = e.target && e.target.closest && e.target.closest('.navigation .navigation__menuitem');
    if (!top) return;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    pts.push({ x: e.clientX, y: e.clientY });
    if (pts.length > 4) pts.shift();
    var row = levelRow(e.target);
    lastRow = row;
    if (!row) return;                                          // padding / bridge: keep current
    if (row === openRow) { clearPending(); return; }
    if (openRow && openRow.isConnected && openRow.parentElement === row.parentElement && aiming()) {
      if (!pendingTimer) { posAtTimer = pts[pts.length - 1]; pendingTimer = setTimeout(safe(recheck), DELAY); }
      return;
    }
    activate(row);
  }

  function onOut(e) {
    if (!openRow) return;
    var top = openRow.closest('.navigation__menuitem');
    var to = e.relatedTarget;
    if (top && to && top.contains(to)) return;
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(safe(function () { closeTimer = null; closeAll(); }), 100);
  }

  function safe(fn) { return function (e) { try { fn(e); } catch (err) { /* never break the page */ } }; }

  function sync() {
    var on = mq ? mq.matches : window.innerWidth >= 981;
    root.classList.toggle(READY, on);
    if (!on) closeAll();
  }

  try {
    document.addEventListener('mousemove', safe(onMove), { passive: true });
    document.addEventListener('mouseover', safe(onMove), { passive: true });
    document.addEventListener('mouseout', safe(onOut), { passive: true });
    document.addEventListener('keydown', safe(function (e) { if (e.key === 'Escape') closeAll(); }));
    if (mq) { mq.addEventListener ? mq.addEventListener('change', safe(sync)) : mq.addListener(safe(sync)); }
    window.sbFlyoutAim = { aiming: aiming, activate: activate, closeAll: closeAll, _state: function () { return { openRow: openRow, pending: !!pendingTimer, pts: pts.slice() }; } };
    sync();                       // adds .sb-aim-ready last, only if everything above worked
  } catch (err) {
    root.classList.remove(READY);
  }
})();